export { default } from './NotificationItem';

export enum Notification {
  PRODUCT_WEDDING_DOWNLOAD_CHECKLIST_CONVERSION_FIRST = 'PRODUCT_WEDDING_DOWNLOAD_CHECKLIST_CONVERSION_FIRST',
  PRODUCT_WEDDING_SUPER_LINK_CONVERSION_FIRST = 'PRODUCT_WEDDING_SUPER_LINK_CONVERSION_FIRST',
  PRODUCT_MARKETPLACE_VENDOR_CONVERSION_FIRST = 'PRODUCT_MARKETPLACE_VENDOR_CONVERSION_FIRST',
  PRODUCT_MARKETPLACE_VENDOR_CONVERSION_SECOND = 'PRODUCT_MARKETPLACE_VENDOR_CONVERSION_SECOND',
  INQUIRY_STOREFRONT_CONNECTED_BOOKED_STATE_STATUS = 'INQUIRY_STOREFRONT_CONNECTED_BOOKED_STATE_STATUS',
  PRODUCT_WEDDING_ADD_EVENT_CONVERSION_FIRST = 'PRODUCT_WEDDING_ADD_EVENT_CONVERSION_FIRST',
  PRODUCT_WEDDING_WEBSITE_CONVERSION_FIRST = 'PRODUCT_WEDDING_WEBSITE_CONVERSION_FIRST',
  PRODUCT_WEDDING_WEBSITE_CONVERSION_SECOND = 'PRODUCT_WEDDING_WEBSITE_CONVERSION_SECOND',
  PRODUCT_WEDDING_GUESTLIST_CONVERSION_FIRST = 'PRODUCT_WEDDING_GUESTLIST_CONVERSION_FIRST',
  POST_WEDDING_FIRST_REFER_FRIENDS = 'POST_WEDDING_FIRST_REFER_FRIENDS',
  PRODUCT_INVITE_SAVE_THE_DATE_CONVERSION_FIRST = 'PRODUCT_INVITE_SAVE_THE_DATE_CONVERSION_FIRST',
  PRODUCT_INVITE_SAVE_THE_DATE_CONVERSION_SECOND = 'PRODUCT_INVITE_SAVE_THE_DATE_CONVERSION_SECOND',
  POST_WEDDING_FIRST_SEND_THANK_YOU_CARDS = 'POST_WEDDING_FIRST_SEND_THANK_YOU_CARDS',
  ADDRESS_COLLECTED = 'ADDRESS_COLLECTED',
  GIFT_RECEIVED = 'GIFT_RECEIVED',
  SURPRISE_GIFT_REVEALED = 'SURPRISE_GIFT_REVEALED',
  PRODUCT_REGISTRY_CONVERSION_FIRST = 'PRODUCT_REGISTRY_CONVERSION_FIRST',
  PRODUCT_REGISTRY_CONVERSION_SECOND = 'PRODUCT_REGISTRY_CONVERSION_SECOND',
  POST_WEDDING_FIRST_SHIP_GIFTS = 'POST_WEDDING_FIRST_SHIP_GIFTS',
  INQUIRY_STOREFRONT_CONNECTED = 'INQUIRY_STOREFRONT_CONNECTED',
  INQUIRY_STOREFRONT_CONNECTED_FIRST_REPLY_REMINDER = 'INQUIRY_STOREFRONT_CONNECTED_FIRST_REPLY_REMINDER',
  INQUIRY_STOREFRONT_CONNECTED_SECOND_REPLY_REMINDER = 'INQUIRY_STOREFRONT_CONNECTED_SECOND_REPLY_REMINDER',
  ORDER_SHIPPED = 'ORDER_SHIPPED',
  RSVP = 'RSVP',
  WELCOME = 'WELCOME',
  WEDDING_DAY_CONGRATS = 'WEDDING_DAY_CONGRATS',
  COMPLETION_DISCOUNT_AWARDED = 'COMPLETION_DISCOUNT_AWARDED',
  POST_WEDDING_FIRST_CREATE_WEDDING_ALBUM = 'POST_WEDDING_FIRST_CREATE_WEDDING_ALBUM',
  POST_WEDDING_FIRST_READ_EXPERT_ADVICE = 'POST_WEDDING_FIRST_READ_EXPERT_ADVICE',
  ORDER_DELIVERED = 'ORDER_DELIVERED',
  FUNDS_TRANSFER_PAID = 'FUNDS_TRANSFER_PAID',
  COMMERCE_PRODUCT_REVIEW_REQUESTED = 'COMMERCE_PRODUCT_REVIEW_REQUESTED',
  POST_WEDDING_FIRST_REVIEW_MARKETPLACE_VENDOR = 'POST_WEDDING_FIRST_REVIEW_MARKETPLACE_VENDOR',
  POST_WEDDING_FIRST_PROMOTE_HOLIDAY_CARDS = 'POST_WEDDING_FIRST_PROMOTE_HOLIDAY_CARDS',
  MARKETPLACE_STOREFRONT_FAVORITED = 'MARKETPLACE_STOREFRONT_FAVORITED',
  BUDGET_TOOL_REMINDER = 'BUDGET_TOOL_REMINDER',
  BUDGET_UPCOMING_PAYMENT_REMINDER = 'BUDGET_UPCOMING_PAYMENT_REMINDER',
  MARKETPLACE_STOREFRONT_OUTREACH = 'MARKETPLACE_STOREFRONT_OUTREACH',
  MARKETPLACE_STOREFRONT_OUTREACH_FIRST_REMINDER = 'MARKETPLACE_STOREFRONT_OUTREACH_FIRST_REMINDER',
}
